import { mergeClassName as e } from "../../utils/data.js";
import { normalizeColorName as t } from "../../utils/colors.js";
import n from "./Banner.module.js";
import { Typography as r } from "../Typography/Typography.js";
import { jsxDEV as i } from "react/jsx-dev-runtime";
//#region lib/components/Banner/Banner.tsx
var a = "/opt/render/project/src/shared-ui/lib/components/Banner/Banner.tsx";
function o({ backgroundColor: o = "neutral", className: s, style: c, children: l, ...u }) {
	return /* @__PURE__ */ i("section", {
		...u,
		style: {
			backgroundColor: `var(--ag-${t(o)}-11)`,
			...c
		},
		className: e(n.banner, s),
		children: typeof l == "string" ? /* @__PURE__ */ i(r, { children: l }, void 0, !1, {
			fileName: a,
			lineNumber: 18,
			columnNumber: 45
		}, this) : l
	}, void 0, !1, {
		fileName: a,
		lineNumber: 13,
		columnNumber: 9
	}, this);
}
//#endregion
export { o as Banner };
